import Vue from 'vue';
import Vuex from 'vuex';
import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters'

Vue.use(Vuex)
// const state={
//     userInfo:{}
// }

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions
})



// WEBPACK FOOTER //
// ./src/vuex/index.js